import classNames from "classnames";
import { ReactNode, useState } from "react";
import { ChevronDown, ChevronUp } from "../../../assets/icons";
import Collapse from "../Collapse/Collapse";
import styles from "./AccordionItem.module.scss";

interface AccordionItemProps {
  title: string;
  children: ReactNode;
  isOpen?: boolean;
  onToggle?: () => void;
  customCssClass?: string;
  contentCssClass?: string;
  noPadding?: boolean;
}

const AccordionItem = ({
  title,
  children,
  onToggle,
  customCssClass,
  contentCssClass,
  noPadding,
  isOpen: isOpenProp,
}: AccordionItemProps) => {
  const [isOpen, setIsOpen] = useState(isOpenProp);
  const open = isOpenProp ?? isOpen;

  const onClick = () => {
    setIsOpen(!open);
    onToggle?.();
  };

  return (
    <section className={classNames(styles.accordion, customCssClass)}>
      <button onClick={onClick} className={classNames(styles.header)}>
        <span className={styles.title}>{title}</span>
        {open ? (
          <ChevronUp size={32} customCssClass={styles.expandIcon} />
        ) : (
          <ChevronDown size={32} customCssClass={styles.expandIcon} />
        )}
      </button>
      <Collapse visible={open}>
        <section className={classNames(styles.content, contentCssClass, noPadding && styles.noPadding)}>
          {children}
        </section>
      </Collapse>
    </section>
  );
};

export default AccordionItem;
